import React from 'react';
import './HelpPage.css';

const HelpPage = () => {
  return (
    <div className="help-page">
      <div className="help-container">
        <div className="help-header">
          <h1>📚 Помощь и поддержка</h1>
          <p className="help-subtitle">Центр помощи MarkApp</p>
        </div>

        {/* Начало работы */}
        <section className="help-section">
          <h2 className="section-title">📱 Начало работы</h2>
          
          <div className="help-cards">
            <div className="help-card">
              <div className="card-icon">1️⃣</div>
              <h3>Регистрация</h3>
              <p>Зарегистрируйтесь через Telegram бот @markapper_bot для быстрого входа в систему.</p>
            </div>

            <div className="help-card">
              <div className="card-icon">2️⃣</div>
              <h3>Настройка VK ORD</h3>
              <p>Добавьте ваш VK ORD токен в настройках приложения для работы с маркировкой рекламы.</p>
            </div>

            <div className="help-card">
              <div className="card-icon">3️⃣</div>
              <h3>Синхронизация</h3>
              <p>Синхронизируйте данные с VK ORD для автоматической загрузки креативов, договоров и контрагентов.</p>
            </div>
          </div>
        </section>

        {/* Часто задаваемые вопросы */}
        <section className="help-section">
          <h2 className="section-title">❓ Часто задаваемые вопросы</h2>

          <div className="faq-list">
            <div className="faq-item">
              <h3>Что такое MarkApp?</h3>
              <p>MarkApp — это веб-приложение для автоматизации маркировки рекламы в соответствии с требованиями законодательства РФ. Приложение интегрируется с VK ORD API и позволяет управлять креативами, договорами, контрагентами и статистикой в едином интерфейсе.</p>
            </div>

            <div className="faq-item">
              <h3>Как получить VK ORD токен?</h3>
              <ol>
                <li>Зарегистрируйтесь на <a href="https://ord.vk.com" target="_blank" rel="noopener noreferrer">ord.vk.com</a></li>
                <li>Перейдите в раздел "Ключ доступа к API"</li>
                <li>Создайте новый API ключ</li>
                <li>Скопируйте токен и добавьте его в настройки MarkApp</li>
              </ol>
            </div>

            <div className="faq-item">
              <h3>Почему не загружаются данные?</h3>
              <p>Проверьте:</p>
              <ul>
                <li>Есть ли подключение к интернету</li>
                <li>Добавлен ли VK ORD токен в настройках</li>
                <li>Авторизованы ли вы в приложении</li>
                <li>Попробуйте синхронизировать данные кнопкой ⟳</li>
              </ul>
            </div>

            <div className="faq-item">
              <h3>Как создать креатив?</h3>
              <ol>
                <li>Откройте вкладку "Контент"</li>
                <li>Нажмите кнопку "+ Добавить" в правом верхнем углу</li>
                <li>Заполните обязательные поля (название, форма, описание)</li>
                <li>Выберите договор и добавьте медиафайлы</li>
                <li>Нажмите "Сохранить"</li>
              </ol>
            </div>

            <div className="faq-item">
              <h3>Как добавить договор?</h3>
              <ol>
                <li>Откройте вкладку "Управление"</li>
                <li>Перейдите на подраздел "Договоры"</li>
                <li>Нажмите "+ Добавить"</li>
                <li>Заполните данные договора (номер, дата, контрагент, сумма)</li>
                <li>Сохраните договор</li>
              </ol>
            </div>

            <div className="faq-item">
              <h3>Как работает синхронизация?</h3>
              <p>MarkApp автоматически синхронизируется с VK ORD API каждые 24 часа. Вы также можете обновить данные вручную, нажав кнопку синхронизации ⟳ на любой странице.</p>
            </div>

            <div className="faq-item">
              <h3>Как получить статус ЕРИР?</h3>
              <p>Статусы ЕРИР (Единый реестр интернет-рекламы) автоматически загружаются при синхронизации. Вы можете вручную обновить статус, нажав кнопку ⟳ в колонке "ЕРИР" для любого объекта (акт, договор, креатив, контрагент).</p>
            </div>

            <div className="faq-item">
              <h3>Безопасно ли хранить токен в приложении?</h3>
              <p>Да, абсолютно безопасно. MarkApp использует защищенное хранилище браузера (localStorage) с HTTPS шифрованием. Все данные передаются через защищенное соединение и недоступны третьим лицам.</p>
            </div>
          </div>
        </section>

        {/* Инструкции */}
        <section className="help-section">
          <h2 className="section-title">📖 Детальные инструкции</h2>

          <div className="instruction-grid">
            <div className="instruction-card">
              <div className="instruction-header">
                <div className="instruction-icon">👤</div>
                <h3>Регистрация и вход</h3>
              </div>
              <ol>
                <li>При первом запуске выберите "Войти через Telegram"</li>
                <li>Откроется бот @markapper_bot в Telegram</li>
                <li>Нажмите "Start" и следуйте инструкциям</li>
                <li>Получите 8-значный код авторизации</li>
                <li>Введите код в приложении</li>
                <li>Готово! Вы авторизованы</li>
              </ol>
            </div>

            <div className="instruction-card">
              <div className="instruction-header">
                <div className="instruction-icon">⚙️</div>
                <h3>Настройка VK ORD</h3>
              </div>
              <ol>
                <li>Откройте раздел "Настройки" (иконка профиля)</li>
                <li>Нажмите на раздел "VK ORD API"</li>
                <li>Получите API ключ на <a href="https://ord.vk.com" target="_blank" rel="noopener noreferrer">ord.vk.com</a></li>
                <li>Вставьте токен в поле ввода</li>
                <li>Нажмите "Сохранить"</li>
                <li>Приложение автоматически загрузит ваши данные из VK ORD</li>
              </ol>
            </div>
          </div>
        </section>

        {/* Контакты поддержки */}
        <section className="help-section">
          <h2 className="section-title">📞 Связаться с поддержкой</h2>

          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <h3>Email</h3>
              <a href="mailto:support@markapp.pro">support@markapp.pro</a>
              <p className="contact-note">Отвечаем в течение 24 часов</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">💬</div>
              <h3>Telegram</h3>
              <a href="https://t.me/lukajamesjr" target="_blank" rel="noopener noreferrer">@lukajamesjr</a>
              <p className="contact-note">Быстрая поддержка в чате</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">🐛</div>
              <h3>Сообщить об ошибке</h3>
              <a href="mailto:bugs@markapp.pro">bugs@markapp.pro</a>
              <p className="contact-note">Подробно опишите проблему</p>
            </div>
          </div>
        </section>

        {/* Полезные ссылки */}
        <section className="help-section">
          <h2 className="section-title">🔗 Полезные ссылки</h2>

          <div className="links-grid">
            <a href="https://ord.vk.com" target="_blank" rel="noopener noreferrer" className="link-card">
              <span className="link-icon">🔗</span>
              <span className="link-text">VK ORD — Официальный сайт</span>
            </a>
            <a href="https://ord.vk.com/help/api" target="_blank" rel="noopener noreferrer" className="link-card">
              <span className="link-icon">📄</span>
              <span className="link-text">VK ORD — Документация API</span>
            </a>
            <a href="https://markapp.pro" target="_blank" rel="noopener noreferrer" className="link-card">
              <span className="link-icon">🏠</span>
              <span className="link-text">Главная страница MarkApp</span>
            </a>
            <a href="https://markapp.pro/privacy" target="_blank" rel="noopener noreferrer" className="link-card">
              <span className="link-icon">🔒</span>
              <span className="link-text">Политика конфиденциальности</span>
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HelpPage;

